import { useState } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Edit02Icon } from '@hugeicons/core-free-icons';
import { IconTrash } from '@tabler/icons-react';
import { CustomersGroup } from '@next-is-free-monorepo/next-is-free-types';
import { useQueryClient } from '@tanstack/react-query';
import { apiV1 } from '../../utils/apiClient';
import { useNavigate } from '@tanstack/react-router';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Button } from '@virlewood/board-79';
import RenameCustomersGroupsModal from './RenameCustomersGroupModal';
import CModal from '../CModal';

interface CustomersGroupOptionsProps {
  group: CustomersGroup;
}

const CustomersGroupOptions = ({ group }: CustomersGroupOptionsProps) => {

  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const deleteGroup = {
    mutationFn: async () => {
      await apiV1.delete(`/shop/customers/groups/${group.id}`);
    },
    onSuccess: async () => {
      await navigate({ to: '/customers/groups', replace: true });
      await queryClient.invalidateQueries({ queryKey: ['customers-groups'] });
    }
  };

  return (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button iconOnly variant={'outline'} size={'sm'} className={'rounded-full'}
                  startIcon={'hugeicons:more-horizontal'} />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => setRenameModalOpen(true)}>
            <HugeiconsIcon size={16} strokeWidth={2} icon={Edit02Icon} />
            Rinomina
          </DropdownMenuItem>
          <DropdownMenuItem variant="destructive" onSelect={() => setDeleteConfirmOpen(true)}>
            <IconTrash size={16} strokeWidth={2} />
            Elimina
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <RenameCustomersGroupsModal group={group} open={renameModalOpen} onClose={() => setRenameModalOpen(false)} />
      <CModal title={'Elimina Gruppo'} text={'Vuoi davvero eliminare questo gruppo?'} open={deleteConfirmOpen}
              onClose={() => setDeleteConfirmOpen(false)} icon={<IconTrash />} color={'red'}
              mutationOptions={deleteGroup} confirmButtonText={'Elimina'} />
    </div>
  );
};
export default CustomersGroupOptions;
